import HttpRequest from "../../services/HttpRequest";

export default class PortalService {

  httpRequest = new HttpRequest();

  startOperation(checkpoint, readPoint, bizLocation, movimentationOrder) {
    const body = {readPoint};
    if (bizLocation) {
      body.bizLocation = {id: bizLocation.id};
    }
    if (movimentationOrder) {
      body.movementOrder = {id: movimentationOrder.id};
    }

    return this.httpRequest.post(`/ton/v1/checkpoint/${checkpoint.id}/transaction-targets`, body);
  }

  pauseOperation(readPointId) {
    return this.httpRequest.put(`/ton/v1/transaction-targets/read-points/${readPointId}/pause`, {});
  }

  finalizeOperation(readPointId) {
    return this.httpRequest.put(`/ton/v1/transaction-targets/read-points/${readPointId}/finalize`, {});
  }

  cancelOperation(readPointId, cause) {
    return this.httpRequest.delete(`/ton/v1/transaction-targets/read-points/${readPointId}?cause=${cause}`);
  }

  getTransaction(readPointId) {
    return this.httpRequest.get(`/ton/v1/transaction-targets/read-points/${readPointId}/portals/transactions`);
  }
}



// WEBPACK FOOTER //
// ./src/pages/PortalPage/PortalService.js